import { useIntl } from 'react-intl'

import Typography from '../../../../../../../components/Typography/Typography'

const TicketOrderInfo = ({ tickets }) => {
    const intl = useIntl()

    return (
        <div className={'order-info d-flex flex-column'}>
            {tickets.map((ticket) => (
                <div key={ticket.ticketid} className={'order-info--row d-flex justify-content-between'}>
                    <Typography variant={'p'}>
                        {`${intl.formatMessage({
                            id: 'userProfile.ticketsAndReserv.ticket',
                        })} - ${intl.formatMessage({
                            id: `buttons.toggle.label.${ticket.customer_category.name ?? 'basic'}`,
                        })}`}
                    </Typography>
                    <Typography variant={'p'}>{`${ticket.price} ${ticket.currency}`}</Typography>
                </div>
            ))}
        </div>
    )
}

export default TicketOrderInfo
